module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_tokyuhands-beac13241b8776c419ee146676c9c3bb.svg";